import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { calendarService, CALENDAR_LEGACY_API_AVAILABLE } from '../api/calendar.service';
import { taskAdapter } from '../adapters';
import { CALENDAR_KEYS } from './queryKeys';
import type { CalendarEvent, DateRange } from '../types';

export function useTaskEvents(
  range: DateRange,
  enabled = true,
): {
  data: CalendarEvent[];
  isLoading: boolean;
  isError: boolean;
} {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: CALENDAR_KEYS.tasks(orgId ?? '', range),
    queryFn: ({ signal }) =>
      calendarService.getTasks(orgId!, { startDate: range.start, endDate: range.end }, signal),
    staleTime: 120_000,
    enabled: !!orgId && enabled && CALENDAR_LEGACY_API_AVAILABLE,
    select: taskAdapter,
  });

  return {
    data: data ?? [],
    isLoading,
    isError,
  };
}
